/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_RewindInputs */

const en_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Rewind`)
};

const fr_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer retour rapide`)
};

const de_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückspulen umschalten`)
};

const it_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva riavvolgimento`)
};

const ru_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить перемотку назад`)
};

const es_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar rebobinar`)
};

const zh_cn2_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换倒带`)
};

const ja_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`巻き戻しを切り替える`)
};

const hi_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवाइंड टॉगल करें`)
};

const pt_pt2_shortcut_keys_name_toggle_rewind = /** @type {(inputs: Shortcut_Keys_Name_Toggle_RewindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar retroceder`)
};

/**
* | output |
* | --- |
* | "Toggle Rewind" |
*
* @param {Shortcut_Keys_Name_Toggle_RewindInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_rewind = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_RewindInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_RewindInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_rewind(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_rewind(inputs)
	return en_shortcut_keys_name_toggle_rewind(inputs)
});